import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLInputElement> {
  static targets = ["clearButton"]
  declare readonly clearButtonTarget: HTMLElement

  clear(): void {
    this.input.value = ""
    this.input.dispatchEvent(new Event("input", { bubbles: true }))
  }

  toggleButton(): void {
    this.clearButtonTarget.hidden = !this.input.value
  }

  private get input(): HTMLInputElement {
    return this.element.querySelector("input[type=text]")!
  }
}
